import styled, { css } from 'styled-components'
import { bustedAsset } from '../bustedAssets'

const designerCSS = css`
  #canvas {
    width: 100%;
    height: 100%;
  }
`

const devHelperCSS = css``

const developerCSS = css``

export const GraphCSS = styled.div`
  position: absolute;
  top: 70px;
  width: 100%;
  height: calc(100% - 70px);
  overflow: hidden;
  border: 1px solir orange;

  ${designerCSS}
  //only for development
  ${devHelperCSS}
  //only for development
  ${developerCSS}
`
